import React, { useMemo } from 'react';
import {
    Box,
    Typography,
    TextField,
    Stack,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    FormHelperText,
    useTheme
} from '@mui/material';
import { styles } from './CryptoWalletFormCss';

const CryptoWalletForm = ({
    formData,
    errors,
    onChange,
    cryptoCurrencies = []
}) => {
    const theme = useTheme();

    // Find the currently selected currency object to populate the networks dropdown
    const selectedCurrencyData = useMemo(() => {
        if (!formData.currency) return null;
        return cryptoCurrencies.find(c => c.code === formData.currency);
    }, [formData.currency, cryptoCurrencies]);

    return (
        <Box>
            <Typography variant="subtitle2" sx={styles.sectionTitle(theme)}>
                Wallet Information
            </Typography>
            <Stack spacing={2}>
                <FormControl size="small" error={Boolean(errors.currency)} fullWidth sx={styles.formControl}>
                    <InputLabel id="currency-select-label">Cryptocurrency</InputLabel>
                    <Select
                        labelId="currency-select-label"
                        id="currency-select"
                        name="currency"
                        value={formData.currency}
                        label="Cryptocurrency"
                        onChange={onChange}
                        sx={styles.inputBorder}
                    >
                        {cryptoCurrencies.map((coin) => (
                            <MenuItem key={coin.code} value={coin.code}>
                                {coin.name} ({coin.code})
                            </MenuItem>
                        ))}
                    </Select>
                    {errors.currency && <FormHelperText>{errors.currency}</FormHelperText>}
                </FormControl>

                <FormControl size="small" error={Boolean(errors.network)} fullWidth sx={styles.formControl} disabled={!formData.currency}>
                    <InputLabel id="network-select-label">Network</InputLabel>
                    <Select
                        labelId="network-select-label"
                        id="network-select"
                        name="network"
                        value={formData.network}
                        label="Network"
                        onChange={onChange}
                        sx={styles.inputBorder}
                    >
                        {selectedCurrencyData?.networks?.map((net) => (
                            <MenuItem key={net.code} value={net.code}>
                                {net.name}
                            </MenuItem>
                        ))}
                    </Select>
                    {errors.network && <FormHelperText>{errors.network}</FormHelperText>}
                </FormControl>

                <TextField
                    size="small"
                    fullWidth
                    label="Wallet Address"
                    name="wallet_address"
                    value={formData.wallet_address}
                    onChange={onChange}
                    error={Boolean(errors.wallet_address)}
                    helperText={errors.wallet_address}
                    placeholder="Enter your wallet address"
                    InputProps={{ sx: styles.inputBorder }}
                />

                <TextField
                    size="small"
                    fullWidth
                    label="Wallet Label"
                    name="wallet_label"
                    value={formData.wallet_label}
                    onChange={onChange}
                    error={Boolean(errors.wallet_label)}
                    helperText={errors.wallet_label || "e.g., My Binance USDT Wallet"}
                    placeholder="Enter a nickname for this wallet"
                    InputProps={{ sx: styles.inputBorder }}
                />


            </Stack>
        </Box>
    );
};

export default CryptoWalletForm;
